import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';

import { sharePitSevices } from 'src/app/services/pitupload/sharePit.service';
import { OpePit } from 'src/app/models/OpePit';
import { PituploadService } from 'src/app/services/pitupload/pitupload.service';
import { OpeEspVtePit } from 'src/app/models/OpeEspVtePit';
import { CommonModule, DatePipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { ProgressBarModule } from 'primeng/progressbar';


@Component({
  selector: 'app-pitupload-espaces-vente',
  templateUrl: './pitupload-espaces-vente.component.html',
  imports: [ButtonModule, FormsModule, ToastModule, ProgressBarModule,CommonModule],
  styleUrls: ['./pitupload-espaces-vente.component.scss'],
  providers: [DatePipe, MessageService]

})
export class PituploadEspacesVenteComponent implements OnInit {

  programmeseled!: OpePit;
  adresse1: string = "";
  adresse2: string = "";
  adresse3: string = "";
  cp: string = "";
  ville: string = "";
  pays: string = "France";
  tel: string = "";
  horaires: string = "";
  listpays: string[] = ["France"];
  espaceVente!: OpeEspVtePit;

  constructor(public datePipe: DatePipe, public pitService: PituploadService, public sharePitSevices: sharePitSevices, private messageService: MessageService, public share: shareOpeSevices) { }

  ngOnInit() {
    this.share.showprogressbar = true;
    this.programmeseled = this.sharePitSevices.pituploadSelectedOpe;
    if (this.programmeseled) {
      this.share.showprogressbar = true;
      this.pitService.getEspVte(this.programmeseled.numOpe).subscribe(res => {
        this.espaceVente = res;
        this.adresse1 = this.espaceVente.adresse1;
        this.adresse2 = this.espaceVente.adresse2;
        this.adresse3 = this.espaceVente.adresse3;
        this.cp = this.espaceVente.codePostal;
        this.ville = this.espaceVente.ville;
        this.pays = this.espaceVente.codePays + "";
        this.tel = this.espaceVente.tel;
        this.horaires = this.espaceVente.horaires;
        this.share.showprogressbar = false;
      },
        error => {
          this.share.showprogressbar = false;
          // console.log(error);
        })
    }
  }

  getEspaceVente() {
    if (this.espaceVente) return structuredClone(this.espaceVente);
    else return {
      numOpe: this.programmeseled.numOpe,
      typeEspace: "",
      adresse1: "",
      adresse2: "",
      adresse3: "",
      ville: "",
      codePostal: "",
      horaires: "",
      langue: "FR",
      codePays: "",
      tel: "",
      publication: 1,
      dc: this.datePipe.transform(new Date, 'yyyy-MM-ddThh:mm:ssZ')?.toString(),
      dm: this.datePipe.transform(new Date, 'yyyy-MM-ddThh:mm:ssZ')?.toString(),
      user: this.sharePitSevices.user
    }
  }

  saveEspaceV() {
    let objUpdate = this.getEspaceVente();
    objUpdate.adresse1 = this.adresse1;
    objUpdate.adresse2 = this.adresse2;
    objUpdate.adresse3 = this.adresse3;
    objUpdate.codePostal = this.cp;
    objUpdate.ville = this.ville;
    objUpdate.tel = this.tel;
    objUpdate.horaires = this.horaires;
    objUpdate.dm = new Date;
    objUpdate.user = this.sharePitSevices.user!;
    this.pitService.updateEspVte(objUpdate).subscribe({
      next: (res) => {
        this.messageService.add({ severity: "success", summary: "Espace de vente", detail: "Modification avec succès" });
        this.espaceVente = res;
        this.adresse1 = this.espaceVente.adresse1;
        this.adresse2 = this.espaceVente.adresse2;
        this.adresse3 = this.espaceVente.adresse3;
        this.cp = this.espaceVente.codePostal;
        this.ville = this.espaceVente.ville;
        this.tel = this.espaceVente.tel;
        this.horaires = this.espaceVente.horaires;
        this.share.showprogressbar = false;
      },
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: "Erreur " + err.status, detail: err.message });
        this.share.showprogressbar = false;
      }
    });
  }
  resetEspaceV() {
    this.adresse1 = this.espaceVente.adresse1;
    this.adresse2 = this.espaceVente.adresse2;
    this.adresse3 = this.espaceVente.adresse3;
    this.cp = this.espaceVente.codePostal;
    this.ville = this.espaceVente.ville;
    this.pays = this.espaceVente.codePays + "";
    this.tel = this.espaceVente.tel;
    this.horaires = this.espaceVente.horaires;
  }
}